import axios from "axios";

const api = axios.create({});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 419) {
            alert("Your session has expired. Please refresh the page.");
            window.location.reload();
        } else if (error.code !== "ERR_CANCELED") {
            console.log("An error occurred:", error.message);
        }
        return Promise.reject(error);
    }
);

export default api;